import React, { useState } from 'react'
import './styles.scss'
export interface ActivationButtonInterface {
  activate: Function
  deactivate: Function
  initialState: boolean
  buttonText?: string[]
  icons?: [string, string]
}
const dataLayer = window.dataLayer || []
export const ActivationButton = ({
  activate,
  deactivate,
  initialState,
  buttonText = ['Karte aktivieren', 'Scrollen aktivieren'],
  icons = ['moving.svg', 'scrolling.svg']
}: ActivationButtonInterface) => {
  const [state, setState] = useState(initialState)
  return (
    <>
      {!state ? (
        <div
          className='buttonText'
          onClick={() => {
            dataLayer.push({
              event: 'Interactions',
              event_action: 'click',
              event_label: 'map-activate'
            })
            activate()
            setState(true)
          }}
        >
          <img src={require('./' + icons[0])} width='30px' />
          <br />
          {buttonText[0]}
        </div>
      ) : (
        <div
          className='buttonText active'
          onClick={() => {
            dataLayer.push({
              event: 'Interactions',
              event_action: 'click',
              event_label: 'map-deactivate'
            })
            deactivate()
            setState(false)
          }}
        >
          <img src={require('./' + icons[1])} width='30px' />
          <br />
          {buttonText[1]}
        </div>
      )}
    </>
  )
}
